import { motion } from "framer-motion";
import { APPLICATION_STEPS } from "@/data/content";
import { SectionHeading } from "@/components/site/primitives";

export function ApplicationProcess({ light = false }) {
  return (
    <section className={`py-20 sm:py-28 ${light ? "bg-white" : "bg-[#F7F5EF]"}`} data-testid="application-process-section">
      <div className="container-x">
        <SectionHeading overline="Application Process" title="From Enquiry to Enrolment in 7 Steps" align="center"
          subtitle="A clear path designed to be easy for both students and parents to follow." />
        <div className="mt-14 relative max-w-3xl mx-auto">
          <div className="absolute left-6 top-0 bottom-0 w-px bg-slate-300" />
          <div className="space-y-6">
            {APPLICATION_STEPS.map((s, i) => (
              <motion.div
                key={s}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="relative flex items-center gap-5 pl-0"
              >
                <div className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#0A1E4E] font-mono text-sm font-bold text-[#D4AF37] ring-4 ring-[#F7F5EF]">
                  {i + 1}
                </div>
                <div className="flex-1 rounded-sm border border-slate-200 bg-white px-5 py-4">
                  <span className="text-xs font-bold uppercase tracking-wide text-[#C0202A]">Step {i + 1}</span>
                  <p className="font-serif text-lg font-bold text-[#0A1E4E]">{s}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
